/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Changes_Log_StartInputs */



/**
* | output |
* | --- |
* | "Starting sync process" |
*
* @param {Sync_Changes_Log_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sync_changes_log_start = /** @type {((inputs?: Sync_Changes_Log_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Changes_Log_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demarrage du processus de synchronisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Synchronisierungsprozess wird gestartet")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio del processo di sincronizzazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запуск процесса синхронизации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando el proceso de sincronización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始同步过程")
	if (locale === "ja") return /** @type {LocalizedString} */ ("同期プロセスを開始しています")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सिंक्रोनाइज़ेशन प्रक्रिया शुरू हो रही है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando o processo de sincronização")
	return /** @type {LocalizedString} */ ("Starting sync process")
});